import React from 'react';
import PropTypes from 'prop-types';
import { Box, CssBaseline, Button, Typography, Skeleton, } from "../../../imports/muiImport";
import { defaultProductImage, HOLICATEGORYLONGBGTHEME, HOLICATEGORYLONGBGTHEME1, NavLink, useSelector } from "../../../imports/generalImport";

import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { Global } from '@emotion/react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { categoryUrl } from '../../../shared/extra';



const drawerBleeding = 56;

const Root = styled('div')(({ theme }) => ({
    height: '100%',
    backgroundColor:
        theme.palette.mode === 'light' ? grey[100] : theme.palette.background.default,
}));

const StyledBox = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

const Puller = styled('div')(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: theme.palette.mode === 'primary' ? grey[300] : grey[900],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));


const dummyCategoryData = [
    {
        "id": 2,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/hxB74MvsrnXNWvDyBDVfZ9lWnJK6FC2uFVwv4zyh.png",
        "title": "Apparel"
    },
    {
        "id": 3,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ApVr6FFZ0jqdCfEvi8296peM6xWkHTfMznJp1FdA.png",
        "title": "Footwear"
    },
    {
        "id": 4,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/BF3LXVbrAR0xUlsKeYUx6Xq8JlGKi8poNiyq0iac.png",
        "title": "E-Commerce"
    },
    {
        "id": 5,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/tHzyPG2v12HJX6EJTtInIaXvFbrubQm5krRWrEkm.png",
        "title": "Accessories"
    },
    {
        "id": 6,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/gBXT9SKuHv9VXxyKbLaSPszCJsmVDW8SzghX59wI.png",
        "title": "Entertainment"
    },
    {
        "id": 7,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/UdI9zgfFEgeX3LpmPhYIwLt0cnOOJ7CGeRRzfBcU.png",
        "title": "Food"
    },
    {
        "id": 8,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ENV4xJWrJ1M9PBxXe04lADi1nfZ87yB9pzKiDq5X.png",
        "title": "Gifting"
    },
    {
        "id": 9,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ll7OE27LtXO6F2hZ4WC1IN9bjmdgjXEmUfoQn1QL.png",
        "title": "Grocery"
    },
    {
        "id": 10,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/yUjvbVocrYoYmNFvbhxZDSd7amRs3jCicUFPxsNI.png",
        "title": "Health"
    },
    {
        "id": 12,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/TOVe4YycDd3KtACpit2IbAhxJRhohmQUXpLiYGxR.png",
        "title": "Jewellery"
    },
    {
        "id": 13,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/bm2iiSNPlMMLfwoF1TZw5MRJ2lSUol5IwyQlUUI1.png",
        "title": "Electronics"
    },
    {
        "id": 14,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/o0mjuoNkw0NesoGLxlX6kg2jfVyEFMP1gIhy10pQ.png",
        "title": "OTT"
    },
    {
        "id": 21,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/mHTQq6VIGZPa4H8SESklp0R5alh2NhnACvJ10n4X.png",
        "title": "Travel"
    },
    {
        "id": 34,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/oxgTZ6j1hWavixIIk1rToY1vQPYOU2SeXTTq8zN3.png",
        "title": "Furniture"
    }
]

function MobileCategoryDrawer(props) {
    const { window, open, setOpen, toggleDrawer } = props;
    const navbarCategory = useSelector((state) => state?.Category?.categories);

    // This is used only for the example
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Root>
            <CssBaseline />
            <Global
                styles={{
                    '.MuiDrawer-root > .MuiPaper-root': {
                        height: `calc(100vh - 170px)`,
                        // height: `calc(100vh - ${drawerBleeding}px)`,
                        overflow: 'visible',
                    },
                }}
            />
            <SwipeableDrawer
                container={container}
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={0}
                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: true,
                }}
            >

                <StyledBox
                    sx={{
                        px: 2,
                        pt: 4,
                        pb: 3,
                        height: '100%',
                        overflow: 'auto',
                        backgroundColor: "#fffbff"
                    }}
                >
                    <Puller />

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateRows: "repeat(2,1fr)",
                            gridTemplateColumns: "repeat(3,1fr)",
                            alignItems: "flex-start",
                            justifyItems: "center",
                            justifyContent: "center",
                            rowGap: 2,
                            columnGap: 2,
                        }}
                    >
                        {navbarCategory?.map((item) => {
                            return (
                                <NavLink
                                    to={`card-list?category=${categoryUrl(item?.title)}`}
                                    key={`drawer-category-${item?.id * 1}`}
                                    style={{
                                        textDecoration: "none",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}>
                                        <Box
                                            component="img"
                                            src={item?.image || defaultProductImage}
                                            width={58}
                                            height={58}
                                        />

                                        <Typography variant='subtitle1' sx={{
                                            width: "100%",
                                            textAlign: "center",
                                            color: "primary.main",
                                            fontWeight: 700,
                                            fontSize: "12.5px"
                                        }}>
                                            {item?.name}
                                        </Typography>
                                    </Box>
                                </NavLink>
                            )
                        })}
                    </Box>
                </StyledBox>
            </SwipeableDrawer>
        </Root>
    );
}


MobileCategoryDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};


export default MobileCategoryDrawer;
